import { render } from "./upload_page.vue?vue&type=template&id=06851998&scoped=true"
import script from "./upload_page.vue?vue&type=script&lang=js"
export * from "./upload_page.vue?vue&type=script&lang=js"

import "./upload_page.vue?vue&type=style&index=0&id=06851998&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06851998"]])

export default __exports__